import React, { Component } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { isDatadogEnabled } from "utils/datadog";
import { isChunkLoadError, reloadOnceForChunkError } from "utils/chunkLoadError";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React Error Boundary caught error:", error, errorInfo);

    if (isDatadogEnabled()) {
      datadogRum.addError(error, {
        source: "react-error-boundary",
        componentStack: errorInfo.componentStack
      });
    }

    // Stale-deploy chunk failures can bubble up here too (any non-route lazy()/commonLoadable
    // usage, not just the router's own errorElement) — try the same one-shot auto-reload before
    // falling back to the static "something went wrong" UI.
    if (isChunkLoadError(error) && reloadOnceForChunkError()) {
      return;
    }

    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Oops, Something went wrong!.</h1>
        </div>
      );
    }
    return this.props.children;
  }
}
